





import { ErrorTooltipTs } from './ErrorTooltipTs';
export default class ErrorTooltip extends ErrorTooltipTs {}
